import { Component, OnInit, ViewChild } from '@angular/core';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { FeatureTogglesFacade } from '@cigna/features';
import { User } from '../manage-access.model';
import { FILTER_GROUP } from '../manage-access.constant';

import { UserOverviewTableComponent } from '../user-overview-table/user-overview-table.component';

@Component({
  selector: 'cigna-page-overview',
  templateUrl: './page-overview.component.html',
  styleUrls: ['./page-overview.component.scss'],
})
export class PageOverviewComponent implements OnInit {
  @ViewChild(UserOverviewTableComponent, { static: true })
  userOverviewTable: UserOverviewTableComponent;

  impersonator$ = this.authFacade.isImpersonator$;
  amUserId$ = this.authFacade.userid$;
  amLob$ = this.authFacade.lob$;

  overviewUsers$ = this.manageAccessFacade.overviewUsers$;

  userTableView$ = this.manageAccessFacade.userTableView$;
  viewingUser$ = this.manageAccessFacade.viewingUser$;
  overviewSelectedFilterGroup$ =
    this.manageAccessFacade.overviewSelectedFilterGroup$;
  overviewFilterText$ = this.manageAccessFacade.overviewFilterText$;
  selectedUsersLength$ = this.manageAccessFacade.selectedUsersLength$;
  hasPreferredLOB$ = this.featureTogglesFacade.featuresEnabled([
    'enablePreferredLOB',
  ]);

  overviewTableFilterActions = [
    {
      label: 'Awaiting Approval',
      value: FILTER_GROUP.awaiting,
    },
    {
      label: 'All Users',
      value: FILTER_GROUP.all,
    },
  ];

  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    private authFacade: AuthFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {}

  ngOnInit() {
    this.manageAccessFacade.reset();
    this.manageAccessFacade.getPendingUsers();
    this.manageAccessFacade.loadDelegationData();
  }

  viewAndEditUsers(): void {
    this.manageAccessFacade.viewAndEditUsers();
  }
  onUserSelectAndEdit(user: User): void {
    this.manageAccessFacade.selectAndEditUser(user);
  }
  onUserSelectChange(changeObject: any): void {
    const checked = changeObject.checked;
    const user = changeObject.user;

    if (checked) {
      this.manageAccessFacade.selectUser(user);
    } else {
      this.manageAccessFacade.unSelectUser(user);
    }
  }
  onUsersToggleAll(checked: boolean): void {
    if (checked) {
      this.manageAccessFacade.selectAllUsersToEdit();
    } else {
      this.manageAccessFacade.unSelectAllUsersToEdit();
    }
  }
  onFilterStateChange(text: FILTER_GROUP): void {
    this.manageAccessFacade.filterStateChange(text);
  }
  onFilterTextChange(text: string): void {
    this.manageAccessFacade.filterTextChange(text);
  }

  addNewUser() {
    this.manageAccessFacade.addNewUsersTrigger();
  }
}
